// Third-party
import React from 'react';
import LoadingSpinner from './LoadingSpinner';
import { FormattedMessageV2 } from '../i18n';

export type Props = {
  titleToLocalize?: string;
  messageToLocalize?: string;
};

const LoadingScreen = ({ titleToLocalize, messageToLocalize }: Props) => (
  <div className="loading-screen" data-testid="loadingScreen">
    <LoadingSpinner />
    {titleToLocalize && <FormattedMessageV2 className="title" toLocalize={titleToLocalize} data-testid="loadingScreen-div-title" />}
    {messageToLocalize && <FormattedMessageV2 className="message" toLocalize={messageToLocalize} data-testid="loadingScreen-div-title" />}
  </div>
);

export default LoadingScreen;
